<template>
  <div v-if="program" class="f-h f-sb">
    <div class="f-v m-tx3">
      <div class="t-xl bold m-b">
        Fulfillment Notification Channel
      </div>
      <div class="t m-bx2">
        The channel Donut will send notifications and reminders to when {{ $i18n.t('shoutouts.reward', { count: 2 }) }} are redeemed.
        <div v-if="!fulfillmentChannel" class="t ital gray m-t">
          Since no channel is currently configured, all Shoutouts admins will instead receive a DM when rewards are redeemed.
        </div>
        <div v-if="!fulfillmentChannel && !adminUserNotificationUnsubscribed" class="t">
          <span class="ital gray">
            As a Shoutouts admin,
          </span>
          <button class="button-reset t link purple c-p d-i-b" @click="toggleNotification(true)">you can opt out of receiving these DMs.</button>
          <div v-if="togglingNotification" class="loading-spinner t-lh-0 d-i-b m-l2 va-m" />
        </div>
        <div v-if="!fulfillmentChannel && adminUserNotificationUnsubscribed" class="t">
          <span class="ital gray">
            As a Shoutouts admin, you have opted out of receiving these DMs.
          </span>
          <button class="button-reset t link purple c-p d-i-b" @click="toggleNotification(false)">You can opt back in.</button>
          <div v-if="togglingNotification" class="loading-spinner t-lh-0 d-i-b m-l2 va-m" />
        </div>
      </div>
    </div>
    <div class="f-ac">
      <p v-if="fulfillmentChannel" class="t m-rx2"><span class="p-2 br-4 bg-medium-blue dark-blue">{{ fulfillmentChannel.name }}</span></p>
      <donut-button
        :class="{inv: !!fulfillmentChannel}"
        :is-loading="state.formSubmitted"
        @click="openFulfillmentChannelModal"
      >
        {{ fulfillmentChannel ? 'Edit' : 'Configure' }}
      </donut-button>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';

const { state, getters, commit, dispatch } = useStore();

const $i18n = inject('$i18n');

const program = computed(() => state.rewardsProgram.program);

const fulfillmentChannel = computed(() => program.value.redemption_fulfillment_channel);

const openFulfillmentChannelModal = () => {
  window.donut.track('Rewards Program - Opened Fulfillment Channel');
  commit('updateModal', {
    visible: true,
    subcomponent: 'rewards-programs-modals-fulfillment-channel',
  });
};

const togglingNotification = ref(false);
const adminUserNotificationKey = 'unsubscribed_from_reward_redeem_admin_notification';
const adminUserNotificationUnsubscribed = computed(() => getters.userNotificationKeyExists(adminUserNotificationKey));
const toggleNotification = async () => {
  togglingNotification.value = true;
  await dispatch('toggleUserNotification', { notificationKey: adminUserNotificationKey });
  togglingNotification.value = false;
};
</script>
